import { type FC, type ReactNode } from 'react'

import { HStack, Screen, VStack, type ScreenProps } from '@/components'

export interface DeadCenterScreenProps extends ScreenProps {
  children: ReactNode
}

export const DeadCenterScreen: FC<DeadCenterScreenProps> = ({ children, ...props }) => (
  <Screen {...props}>
    <HStack
      // center all content
      className='flex-1 items-center justify-center'
    >
      <VStack
        // limit the content to be the size of a 640px (sm) wide screen
        className='w-full max-w-sm gap-4'
      >
        {children}
      </VStack>
    </HStack>
  </Screen>
)
